module.exports = __webpack_public_path__ + "img/g2.a8b1c00a.png";